import { Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import PurchaseOrderDashboard from './PurchaseOrderDashboard';
import ApprovedPurchaseOrderDashboard from './ApprovedPurchaseOrderDashboard';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPurchaseOrdersFilters } from '../../../containers/actions/common/purchaseOrderAction';
import usePrevious from '../../helpers/previousProps';
import { getFeaturesAccess } from '../../../containers/actions/common/accessControl';

const defaultTableColumns = () => {
  let result = {
    poBeforeApproveColumns: [
      { active: true, id: 'poline', tableHeader: "PO Number" },
      { active: true, id: 'dateOfCreation', tableHeader: "Date of Creation" },
      { active: true, id: 'poStatus', tableHeader: "PO Status" },
      {
        active: true,
        id: localStorage.collabType === 'CMO' ? 'BMS' : 'cdmoPlant',
        tableHeader: localStorage.collabType === 'CMO' ? 'BMS' : "CMO"
      },
      { active: true, id: 'actions', tableHeader: "Actions" },
      { active: true, id: 'productCodeDescription', tableHeader: "Product Code / Description" },
    ],
    poApprovedColumn:[
    { active: true, id: 'poline', tableHeader: "PO - Line" },
    { active: true, id: 'dateOfDelivery', tableHeader: "Date of Delivery" },
    { active: true, id: 'poStatus', tableHeader: "PO Status" },
      {
        active: true,
        id: localStorage.collabType === 'CMO' ? 'BMS' : 'cdmoPlant',
        tableHeader: localStorage.collabType === 'CMO' ? 'BMS' : "CMO - Plant ID"
      },
    { active: true, id: 'deliveredQty', tableHeader: "Delivered Qty. (%)" },
    { active: true, id: 'actions', tableHeader: "Actions" },
    { active: true, id: 'productCodeDescription', tableHeader: "Product Code / Description" },
    { active: true, id: 'viewBatches', tableHeader: "View Batches" },
    ]
  }
  
  return result;
} ;

const PurchaseOrderTabs = () => {
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const [savedFilter, setSavedFilter] = useState({});
  const [customizeTable, setCustomizeTable] = useState([]);

  const purchaseOrderFilter = useSelector((state) =>
      state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters?.status
        ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters
        : {}
  );
  
  const screenAccess = useSelector(
      (state) =>
        state.pcmp.common.accessControl.screensAccess?.data.poManagementDashboard
    );
  
    const featuresAccess = useSelector(
      (state) =>
        state.pcmp.common.accessControl.featuresAccess.poManagementFeatures
    );
  
    useEffect(() => {
      if (screenAccess?.screenAccess && !featuresAccess)
        dispatch(getFeaturesAccess(screenAccess?.screenId, 'poManagementFeatures')); 
      // We can pick up DS screen Id from access screensAccess.data.deliverySchedule.screenId
    }, [dispatch, screenAccess, featuresAccess]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  
  useEffect(() => {
    dispatch(fetchPurchaseOrdersFilters());
  }, [])

  let previousPurchaseOrderFilter = usePrevious(purchaseOrderFilter)

  
  useEffect(() => {
      if (
        JSON.stringify(purchaseOrderFilter) !==
        JSON.stringify(previousPurchaseOrderFilter)
      ) {
        setSavedFilter(purchaseOrderFilter?.save_filter_options && typeof purchaseOrderFilter?.save_filter_options === "object" ? purchaseOrderFilter?.save_filter_options : {})

        if (purchaseOrderFilter?.customize_columns && typeof purchaseOrderFilter?.customize_columns === "object" && Object.keys(purchaseOrderFilter?.customize_columns).length !== 0) {
          let customiseCloumns = {}
          if (purchaseOrderFilter?.customize_columns?.poApprovedColumn && Array.isArray(purchaseOrderFilter?.customize_columns?.poApprovedColumn) && purchaseOrderFilter?.customize_columns?.poApprovedColumn.length === 0) {
            customiseCloumns = {
              ...customiseCloumns,
              poApprovedColumn : defaultTableColumns.poApprovedColumn
            }
          } 

          if (purchaseOrderFilter?.customize_columns?.poBeforeApproveColumns && Array.isArray(purchaseOrderFilter?.customize_columns?.poBeforeApproveColumns) && purchaseOrderFilter?.customize_columns?.poBeforeApproveColumns.length === 0) {
            customiseCloumns = {
              ...customiseCloumns,
              poBeforeApproveColumns : defaultTableColumns.poBeforeApproveColumns
            }
          } 

          if (purchaseOrderFilter?.customize_columns?.poApprovedColumn && Array.isArray(purchaseOrderFilter?.customize_columns?.poApprovedColumn) && purchaseOrderFilter?.customize_columns?.poApprovedColumn.length === 0
            && purchaseOrderFilter?.customize_columns?.poBeforeApproveColumns && Array.isArray(purchaseOrderFilter?.customize_columns?.poBeforeApproveColumns) && purchaseOrderFilter?.customize_columns?.poBeforeApproveColumns.length === 0
          ) {
            setCustomizeTable(customiseCloumns)
          } else {
            setCustomizeTable(purchaseOrderFilter?.customize_columns)
          }

          // setCustomizeTable(purchaseOrderFilter?.customize_columns)
        } else {
          setCustomizeTable(defaultTableColumns)
        }
            
          
      }
  }, [previousPurchaseOrderFilter, purchaseOrderFilter]);
  

  return (
      <React.Fragment>
          <Tabs
    value={tabIndex}
    onChange={handleTabChange}
    indicatorColor='secondary'
    textColor='secondary'
    variant='scrollable'
    scrollButtons='auto'
  >
      <Tab
        label={'Before approval'}
        value={0}
        style={{ textTransform: 'none' }}
          />
          <Tab
        label={'Approved'}
        value={1}
        style={{ textTransform: 'none' }}
      />
          </Tabs>
          
      {tabIndex === 0 && <PurchaseOrderDashboard savedFilter={savedFilter} customizeTable={customizeTable} featuresAccess={featuresAccess} />}

      {tabIndex === 1 &&  <ApprovedPurchaseOrderDashboard savedFilter={savedFilter} customizeTable={customizeTable} featuresAccess={featuresAccess} />}
          
      </React.Fragment>
  )
}

export default PurchaseOrderTabs